import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Home = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m3.332 10.27 8-7.172a1 1 0 0 1 1.335 0l8 7.173a1 1 0 0 1 .333.744V19.5a1 1 0 0 1-1 1h-5.2a1 1 0 0 1-1-1v-2.965a1 1 0 0 0-1-1h-1.6a1 1 0 0 0-1 1V19.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8.484a1 1 0 0 1 .332-.745"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Home) as SvgIcon;
export { ForwardRef as ReactComponent };
